// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__UDEu0","location":"LocationSection_location__0GEVY"};